<template>
  <v-layout row>
    <v-flex xs12>
      <v-card>
      <v-layout row>
        <v-flex xs2>
          <v-text-field
            v-model=scp.estimatedTons
            label="Est Tons"></v-text-field>
        </v-flex>
        <v-flex xs2>
          <v-text-field
            v-model=scp.estDaysInTank
            label="Est Days in Tank"></v-text-field>
        </v-flex>
        <v-flex xs2>
          <v-text-field
            v-model=scp.sulphurPPM
            label="Sulphur PPM"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs3>
          <v-autocomplete single-line v-on:change="vineyardChanged"
            :value ='scp.vineyardid'
            :items='vineyards'
            item-text='name'
            item-value='id'
            return-object
            label='Vineyard'
          ></v-autocomplete>
        </v-flex>
        <v-flex xs3>
          <v-text-field
            :value=scp.Location.appellation
            readonly
            label="Appellation"></v-text-field>
        </v-flex>
        <v-flex xs3>
          <v-text-field
            :value=scp.Location.region
            readonly
            label="Crop Report Zone"></v-text-field>
        </v-flex>
        <v-flex xs2>
        </v-flex>
        <v-flex xs2>
          <v-btn v-if='scp.id >= 0 && scp.vineyardid && isStaff()> 0' :color='getColor("WT")' @click='createWT'>CREATE WT</v-btn>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs3>
          <v-autocomplete single-line v-on:change="varietalChanged"
            v-model = 'wo.SCPs[0].varietal'
            :items='varietals'
            item-text='name'
            item-value='id'
            label='Varietal'
          ></v-autocomplete>
        </v-flex>
       <v-flex xs3>
          <v-text-field
            v-model = 'wo.SCPs[0].clone'
            label="Clone"></v-text-field>
        </v-flex>
      </v-layout>
      </v-card>
      <br>
      <v-card>
        <v-layout row>
          <v-flex xs3 v-if="!isWhite">
            <v-select
              v-model = 'wo.SCPs[0].handSorting'
              :items='yesNo'
              return-object
              label="Hand Sorting">
            </v-select>
          </v-flex>
          <v-flex xs3 v-else>
            <br>
            <span>DIRECT TO PRESS</span>
          </v-flex>
          <v-flex xs3></v-flex>
          <v-flex xs5>
            <v-slider v-model='wo.SCPs[0].wholeCluster'
             label="% Whole Cluster"
              thumb-label="always"
               step=1>
            </v-slider>
          </v-flex>
          <v-flex xs1></v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs3>
            <v-select
              v-model='wo.SCPs[0].crushing'
              :items='crushing'
              return-object
              label="Crushing">
            </v-select>
          </v-flex>
          <v-flex xs3></v-flex>
          <div v-if="wo.SCPs[0].varietal">
            <v-flex xs3 v-if="wo.SCPs[0].varietal.type=='RED'">
              <v-select
                v-model='wo.SCPs[0].tankPosition'
                :items='tankPosition'
                return-object
                label="Tank Position">
              </v-select>
            </v-flex>
          </div>
          <v-flex xs3 v-else>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-textarea
              outline
              label="Special Instructions"
              v-model='wo.SCPs[0].specialInstructions'
              ></v-textarea>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import myMixins from '../mixins/myMixins'
export default {
  props: ['wo'],
  data () {
    return {
      menu: false,
      slider: 20,
      localWO: {}
    }
  },
  mixins: [myMixins],
  methods: {
    createWT () {
      this.$router.push({
        path: '/weightag/-1',
        query: {
          scpid: this.wo.SCPs[0].id
        }
      }
      )
    },
    varietalChanged (value) {
      this.$emit('scpUpdated')
      if (isWhite) {
        this.wo.SCPs[0].handSorting = 'DIRECTTOPRESS'
      }
    },
    vineyardChanged (value) {
      this.$emit('scpUpdated')
      let $this = this
      this.$store.state.vineyards.forEach(function (item) {
        if (item.id === value.id) {
          $this.wo.SCPs[0].Location = item
          $this.wo.SCPs[0].vineyardid = item.id
        }
      })
    },
    updateLot () {
      this.$emit('scpUpdated')
    },
    saveDate (date) {
      this.$emit('scpUpdated')
      this.wo.date = moment(date).add(5, 'hours').format('YYYY-MM-DDThh:mm:ss')
      this.menu = false
    }
  },
  computed: {
    scp () {
      return this.wo.SCPs[0]
    },
    vineyards () {
      return this.$store.state.vineyards
    },
    isWhite () {
      for (var i=0; i < this.varietals.length; i++) {
        if (this.varietals[i].name === this.wo.SCPs[0].varietal) {
          return this.varietals[i].type === 'WHITE'
        }
      }
    },
    varietals () {
      return this.$store.state.varietals
    }
  }
}
</script>

<style>
.largeSelect {
    width: 300px
  }
</style>
